import { serverApi } from "../../../config/Keys";
import axios from "axios";

export const get_session_automate = async (token, onSuccess) => {
  try {
    let response = await axios.get(`${serverApi}/session-automate`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (response.data) {
      onSuccess(response.data);
    }
  } catch (err) {
    console.log(err);
  }
};

export const complete_all_orders_from_sessions = async (
  token,
  type,
  ids,
  onSuccess
) => {
  try {
    let response = await axios.patch(
      `${serverApi}/session-automate?type=${type}`,
      { order_ids: ids },
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data && onSuccess) {
      onSuccess(response.data);
    }
  } catch (err) {
    console.log(err);
  }
};
